import { render } from "./MonsterTypeCompendiumModal.vue?vue&type=template&id=4a78f24c"
import script from "./MonsterTypeCompendiumModal.vue?vue&type=script&lang=js"
export * from "./MonsterTypeCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__